import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import DriverAddOrUpdate from "./DriverAddOrUpdate";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import dayjs from "dayjs";
const ModalDriver = ({ modalShow, setModalShow, isTitle, hubData }) => {
    // const [licenceExpiryDate, setLicenceExpiryDate] = useState(null);
    const [isRedirect, setIsRedirect] = useState(false);
    const [licenceExpiryDate, setLicenceExpiryDate] = useState(
        hubData?.licenseExpiry ? dayjs(hubData?.licenseExpiry) : null
    );
    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/pnd_vehicle/view" />;
    }
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

    const handleSubmit = async (formValues) => {
        try {
            formValues["driverEmployerInfo"] = {
                driverEmployerId: formValues["driverEmployerInfo"]["value"]
            };
            // formValues["licenseExpiry"] = licenceExpiryDate;

            formValues["licenseExpiry"] = licenceExpiryDate;
            if (formValues["licenseExpiry"]) {
                const date = new Date(formValues["licenseExpiry"]);
                if (!isNaN(date.getTime())) {
                    formValues["licenseExpiry"] = date.toISOString();
                }
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Please select Expiry Date.`,
                );
                return;
            }
            if (formValues["driverId"] == null || formValues["driverId"] === 'undefined')
                formValues["driverId"] = null;
            // formValues["licenseExpiry"] = licenceExpiryDate || formValues["licenseExpiry"];
            const response = await PndRestApi.AddOrUpdateDriver(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4 className="text-modal  modal__title mt-1 text-uppercase"  >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                        {/* form  */}
                        {hubData ?
                            <DriverAddOrUpdate
                                onSubmit={handleSubmit} hubData={hubData}
                                status={hubData.status} setLicenceExpiryDate={setLicenceExpiryDate} licenceExpiryDate={licenceExpiryDate}
                                vehicleStatus={hubData?.vehicleId != null ? true : false} hubStatus={hubData?.hubId != null ? true : false}
                            /> :
                            <DriverAddOrUpdate
                                onSubmit={handleSubmit} setLicenceExpiryDate={setLicenceExpiryDate}
                            />
                        }
                        {/* </span>
                        </span> */}
                    </div>

                </ModalBody>
            </Modal>

        </div>
    );
};


export default connect((state) => ({
    rtl: state.rtl,
}))(ModalDriver);
